<div class="header-container">
  <div class="brand-title">{{ 'brand_name.title' | translate }}</div>
  <div class="form-field-container">
    <mat-form-field appearance="fill" class="form-field">
      <mat-label class="label red-label">{{ 'brand_name.items' | translate }}</mat-label>
      <mat-select
        [(ngModel)]="selectedItems"
        (selectionChange)="onItemSelect($event)"
        (openedChange)="focusSearchInput()"
      >
        <mat-option>
          <input
            matInput placeholder="{{ 'brand_name.search' | translate }}"
            [(ngModel)]="searchTerm"
            (input)="searchBrandName()"
            (focus)="$event.stopPropagation()"
            (click)="$event.stopPropagation()"
            #searchInput
          />
        </mat-option>
        <ng-container *ngIf="items.length === 0">
          <mat-option disabled>{{ 'brand_name.not_result' | translate }}</mat-option>
        </ng-container>
        <mat-option *ngFor="let item of items" [value]="item">
          <div class="item-option">
            {{ item.name }} - {{ item.type }}
          </div>
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>
<span class="table-title">{{ 'brand_name.table-brand-name-config' | translate }} ({{ brandNameConfig.length }})</span>
<div class='mat-table-container'>
  <mat-table [dataSource]='dataSource'>
    <ng-container matColumnDef='stt'>
      <mat-header-cell *matHeaderCellDef>
        {{ 'form.stt' | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef='let element' matTooltip='{{element.stt}}'>
        <span class="fix-width"> {{paginate.no[dataSource.filteredData.indexOf(element)]}}</span>
      </mat-cell>
    </ng-container>

    <!-- CpCode Column -->
    <ng-container matColumnDef='name'>
      <mat-header-cell *matHeaderCellDef>
        {{ 'form.brand_name' | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef='let element' matTooltip='{{element.name}}'>
        <span class='fix-width'>{{ element.name.slice(0, 99) }}</span>
      </mat-cell>
    </ng-container>

    <!-- UserName Column -->
    <ng-container matColumnDef='username'>
      <mat-header-cell *matHeaderCellDef>
        {{ 'form.username' | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef='let element' matTooltip='{{ element.username }}'>
        <span class='fix-width'>{{ element.username }}</span>
      </mat-cell>
    </ng-container>

    <!-- Password Column -->
    <ng-container matColumnDef='type'>
      <mat-header-cell *matHeaderCellDef>
        {{ 'form.type' | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef='let element' matTooltip='{{ element.type }}'>
        <span class='fix-width'>{{ element.type }}</span>
      </mat-cell>
    </ng-container>

    <!-- Action Column -->
    <ng-container matColumnDef="action">
      <mat-header-cell *matHeaderCellDef>
        {{ 'form.edit' | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <span class="fix-width">
        <button mat-icon-button (click)="editBrandName(element)">
          <mat-icon matTooltip="{{'department_manage.buttons.edit' | translate}}">
            edit
          </mat-icon>
        </button>
        </span>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef='displayedColumns; sticky: true'></mat-header-row>
    <mat-row *matRowDef='let row; columns: displayedColumns'></mat-row>
  </mat-table>
  <div class='d-flex justify-content-end' [class.justify-content-center]='paginate.totalRow === 0'>
    <app-pagination [(paginate)]='paginate' (pageChange)="loadData($event.page, $event.pageSize)">
    </app-pagination>
  </div>

</div>
